import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { accountService } from '../../services/accountService';
import { CloseOutlined } from '@ant-design/icons';

const AccountPasswordForm = ({ visible, account, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && account) {
      form.resetFields();
      // 设置账号字段的初始值
      form.setFieldsValue({
        loginId: account.loginId
      });
    }
  }, [visible, account, form]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      
      // 构造API请求数据
      const passwordData = {
        loginId: account.loginId,
        password: values.password,
        passwordEncryptType: "0" // 固定值
      };
      
      const response = await accountService.changePassword(passwordData);
      
      if (response.success) {
        message.success(t('account.changePasswordSuccess'));
        onSuccess();
      } else {
        message.error(response.errorMessage || t('account.changePasswordFailed'));
      }
    } catch (error) {
      console.error('修改密码失败:', error);
      message.error(error.mgessage || t('account.changePasswordFailed'));
    } finally {
      setLoading(false);
    }
  };

  const modalTitle = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{t('account.passwordTitle')}</span>
      <CloseOutlined onClick={onCancel} style={{ cursor: 'pointer' }} />
    </div>
  );

  return (
    <Modal
      title={modalTitle}
      open={visible}
      onCancel={onCancel}
      destroyOnClose
      width={600}
      closable={false}
      className="account-password-modal"
      footer={[
        <div key="footer" style={{ textAlign: 'right', padding: '10px 0' }}>
          <button 
            className="submit-button"
            onClick={handleSubmit}
            disabled={loading}
          >
            {t('common.submit')}
          </button>
        </div>
      ]}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="loginId"
          label={t('account.account')}
        >
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="password"
          label={<span className="required-label">{t('account.password')}</span>}
          rules={[
            { required: true, message: t('account.passwordRequired') },
            { min: 8, max: 20, message: t('account.passwordLengthRequired') },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,20}$/,
              message: t('account.passwordComplexityRequired')
            }
          ]}
        >
          <Input.Password placeholder={t('common.pleaseInput')} maxLength={20} />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label={<span className="required-label">{t('account.confirmPassword')}</span>}
          dependencies={['password']}
          rules={[
            { required: true, message: t('account.confirmPasswordRequired') },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t('account.passwordMismatch')));
              },
            }),
          ]}
        >
          <Input.Password placeholder={t('common.pleaseInput')} maxLength={20} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AccountPasswordForm; 